import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import useAnimatedCount, { formatCount } from "./useAnimatedCount";

const StatCard = ({ color, icon, label, sub, value, valueClassName, animate }) => {
  const animated = useAnimatedCount(value, animate);
  const display = animate ? formatCount(animated) : formatCount(value);

  return (
    <div className={`stat-card ${color}`}>
      <div className="stat-icon">{icon}</div>
      <div className="stat-label">{label}</div>
      <div className={`stat-value${valueClassName ? ` ${valueClassName}` : ""}`}>{display}</div>
      <div className="stat-sub">{sub}</div>
    </div>
  );
};

StatCard.propTypes = {
  color: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  sub: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  valueClassName: PropTypes.string,
  animate: PropTypes.bool
};

StatCard.defaultProps = {
  valueClassName: "",
  animate: true
};

const HomeStats = ({ apiCount, engineCount, usageCount, tokenBalance, animate }) => {
  const { t } = useTranslation("common");

  return (
    <div className="stats-grid">
      <StatCard
        color="blue"
        icon="📡"
        label={t("My APIs")}
        sub={t("Active endpoints")}
        value={apiCount}
        animate={animate}
      />
      <StatCard
        color="purple"
        icon="⚙️"
        label={t("Engine Configs")}
        sub={t("Odoo connections")}
        value={engineCount}
        animate={animate}
      />
      <StatCard
        color="cyan"
        icon="🔥"
        label={t("Web API Usage")}
        sub={t("Calls this month")}
        value={usageCount}
        animate={animate}
      />
      <StatCard
        color="green"
        icon="🪙"
        label={t("Token Balance")}
        sub={t("Available tokens")}
        value={tokenBalance}
        valueClassName="tokens"
        animate={animate}
      />
    </div>
  );
};

HomeStats.propTypes = {
  apiCount: PropTypes.number.isRequired,
  engineCount: PropTypes.number.isRequired,
  usageCount: PropTypes.number.isRequired,
  tokenBalance: PropTypes.number.isRequired,
  animate: PropTypes.bool
};

HomeStats.defaultProps = {
  animate: true
};

export default HomeStats;
